import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { asMetricWindow, DEFAULT_METRIC_WINDOW, type MetricWindow } from '@/features/projects/metric-window';
import { ProjectMetricsPage } from '@/features/projects/project-metrics-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Métriques d'un projet (porting README #28) ; la période vit dans l'URL (`?window=day`). */
export const Route = createFileRoute('/$tenant/projects/$projectId/metrics')({
  validateSearch: (search: Record<string, unknown>): { window?: MetricWindow } => {
    const period = asMetricWindow(search['window']);
    return period === DEFAULT_METRIC_WINDOW ? {} : { window: period };
  },
  component: ProjectMetricsRoute,
});

function ProjectMetricsRoute() {
  const { tenant, projectId } = Route.useParams();
  const { window: period = DEFAULT_METRIC_WINDOW } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="overview"
      crumbs={[{ label: t('projectMetrics.short') }]}
    >
      <ProjectMetricsPage
        tenantId={tenant}
        projectId={projectId}
        period={period}
        onPeriodChange={(next) =>
          void navigate({ search: next === DEFAULT_METRIC_WINDOW ? {} : { window: next }, replace: true })
        }
      />
    </ConsoleShell>
  );
}
